import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { VideoStatus, ItemPlaceholderBoxView, ItemPlaceholderBoxViewFooterType, videoIcon } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useNonActiveVideoPreviewStyle } from '../styles';

const VideoStatusPreviewConfig = {
  [VideoStatus.Draft]: {
    text: {
      summary: _TL_('Processing.'),
      tip: _TL_('When processing is complete, you can preview your asset here.'),
    },
  },

  [VideoStatus.Transcoding]: {
    text: {
      summary: _TL_('Processing.'),
      tip: _TL_('When processing is complete, you can preview your asset here.'),
    },
  },

  [VideoStatus.Unverified]: {
    text: {
      summary: _TL_('Downloading.'),
      tip: _TL_('When the download is complete, you can preview your asset here.'),
    },
  },

  [VideoStatus.Failed]: {
    type: ItemPlaceholderBoxViewFooterType.warning,
    fabricIconName: 'Warning',
    fabricIconDynamicClassName: 'failedIconContainer',
    text: {
      summary: _TL_('Invalid.'),
      tip: _TL_('Delete the asset and try again.'),
      learnMoreLinkText: _TL_('Learn more about asset guidelines and accepted file types.'),
    },
    learnMoreLinkTopic: 'app54863',
  },
};

export const NonActiveVideoPreview = ({
  status,
  i18n,
}) => {
  const classes = useNonActiveVideoPreviewStyle();
  const footerProps = useMemo(() => {
    const mappedConfig = VideoStatusPreviewConfig[status];
    const localizedTextFields = _.mapObject(
      mappedConfig.text,
      text => i18n.getString(text)
    );

    return {
      type: mappedConfig.type,
      learnMoreLinkTopic: mappedConfig.learnMoreLinkTopic,
      fabricIconName: mappedConfig.fabricIconName,
      fabricIconClassName: classes[mappedConfig.fabricIconDynamicClassName],
      ...localizedTextFields,
    };
  }, [classes, i18n, status]);

  return (
    <ItemPlaceholderBoxView
      className={classes.container}
      mainViewIcon={videoIcon}
      mainViewIconLabel={i18n.getString(_TL_('Video'))}
      footerProps={footerProps}
    />
  );
};

NonActiveVideoPreview.propTypes = {
  status: PropTypes.oneOf(Object.keys(VideoStatus)).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
